"use client";

import { Facebook, Instagram, Twitter, Youtube, ArrowRight, Check, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="grid grid-cols-2 gap-x-8 gap-y-3">
        {Array.from({
        length: 8
      }).map((_, i) => <div key={i} data-index={i} className="h-5 w-28 bg-[hsl(215_50%_25%)] animate-pulse rounded-md" />)}
      </div>;
  }
  const items = menuItems.slice(0, 8);
  const padded = [...items, ...Array.from({
    length: Math.max(0, 8 - items.length)
  })];
  return <ul className="grid grid-cols-2 gap-x-8 gap-y-3">
      {padded.map((item, i) => <li data-index={i} key={i} className="flex items-baseline gap-2">
          <span className="font-default text-xs tracking-widest" style={{
        color: "#FFCA2C"
      }} aria-hidden="true">
            {`→${String(i + 1).padStart(2, "0")}`}
          </span>
          {item ? <Link to={(item as {
        href?: string;
      }).href || "#"} className="group relative inline-block text-[15px] font-semibold text-white hover:text-[#FFCA2C] transition-colors duration-200">
              <span className="relative">
                {(item as {
            label: string;
          }).label}
              </span>
            </Link> : <span className="text-[15px] font-semibold text-white/30">—</span>}
        </li>)}
    </ul>;
}
const socials = [{
  name: "Twitter",
  href: "#"
}, {
  name: "Instagram",
  href: "#"
}, {
  name: "Facebook",
  href: "#"
}, {
  name: "Youtube",
  href: "#"
}];
function SocialIcon({
  name
}: {
  name: string;
}) {
  const cls = "w-5 h-5";
  if (name === "Twitter") return <Twitter className={cls} strokeWidth={2.5} />;
  if (name === "Instagram") return <Instagram className={cls} strokeWidth={2.5} />;
  if (name === "Facebook") return <Facebook className={cls} strokeWidth={2.5} />;
  return <Youtube className={cls} strokeWidth={2.5} />;
}
export default function Footer() {
  return <section data-section-id="1128" id="legacy-security-footer" className="relative overflow-hidden bg-[#061F3F] py-20 md:py-24 text-white">
      <div className="relative max-w-[1440px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-10 w-auto text-white" />
            </Link>
            <h2 className="mt-6 text-3xl font-bold font-default text-[#FFCA2C]">
              PROTECT YOUR LEGACY. PROTECT YOUR FAMILY.
            </h2>
            <p className="mt-4 text-sm leading-relaxed font-default text-white">
              By submitting this form, you agree to receive calls, text messages, and emails regarding insurance products and services. Consent is not a condition of purchase.
            </p>

            <div className="mt-8 flex items-center gap-4">
              {socials.map((s, i) => <Link data-index={i} key={s.name} to={s.href} aria-label={s.name} className="group relative inline-flex items-center justify-center w-11 h-11 rounded-md border border-[#FFCA2C] bg-[#061F3F] text-[#FFCA2C] hover:bg-[#FFCA2C] hover:text-[#061F3F] transition-all duration-300">
                  <SocialIcon name={s.name} />
                </Link>)}
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="font-default text-xs uppercase tracking-[0.18em] mb-5 font-bold" style={{
            color: "#FFCA2C"
          }}>
              § QUICK LINKS
            </p>
            <MenuProvider menu_id="footer_menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="md:col-span-3">
            <p className="font-default text-xs uppercase tracking-[0.18em] mb-4 font-bold" style={{
            color: "#FFCA2C"
          }}>
              § TRUST SIGNALS
            </p>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <Shield className="w-5 h-5 text-[#10B981]" />
                <span className="text-sm font-default">LICENSED INSURANCE AGENT</span>
              </div>
              <div className="flex items-center gap-3">
                <Check className="w-5 h-5 text-[#10B981]" />
                <span className="text-sm font-default">PROUDLY SERVING FAMILIES</span>
              </div>
              <div className="flex items-center gap-3">
                <Shield className="w-5 h-5 text-[#10B981]" />
                <span className="text-sm font-default">COMMITMENT TO PEACE OF MIND</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/20 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="font-default text-xs uppercase tracking-[0.18em] text-white">
            © 2025 FAMILY LEGACY PLANNING
          </p>
          <div className="flex gap-6">
            <Link to="#" className="text-xs text-white underline font-default">Terms & Conditions</Link>
            <Link to="#" className="text-xs text-white underline font-default">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </section>;
}